import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { branch, compose, renderNothing, withHandlers, withState } from 'recompose';

import { isBarberUser } from '../../../../auth/selectors';
import {
  closeAppointmentModal,
} from '../../actions';
import { selectTab as selectRegisterTab } from '../../../../register/sale/actions';
import { closeChargeModal } from '../../../../register/payment/reducer/chargeModal/actions';
import { SERVICES_TAB, PRODUCTS_TAB } from '../../../../register/sale/constants';
import withPermissions from '../../../../auth/utils/withPermissions';
import { canUserViewRegister } from '../../../../common/helpers/users';
import { addAppointment } from '../../../../register/order/actions';
import GoToRegisterButtons from '../components/GoToRegisterButtons';
import withCheckBarberIsClockedIn from '../../../timeTracker/hoc/withCheckBarberIsClockedIn';
import { withPaymentInfoSetupStatus } from '../../../../common/hoc/paymentInfoSetupStatus';
import { CustomerIoTracker, APPOINTMENT_CHARGE_STARTED } from '../../../../../modules/infra/observability/customer-io';

const mapStateToProps = state => ({ isBarberUser: isBarberUser(state) });

const mapDispatchToProps = ({
  closeAppointmentModal,
  addAppointment,
  selectRegisterTab,
  closeChargeModal,
});

const enhance = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withState('submitting', 'setSubmitting', false),
  withPermissions,
  withPaymentInfoSetupStatus,
  withHandlers({
    goToRegister: props => (tabToOpen) => {
      props.setSubmitting(true);
      let start = Promise.resolve(props.appointment);

      if (props.areChangesPending) {
        start = start.then(() => props.updateAppointment(null, true, false));
      }

      return start.then((appointment) => {
        props.setSubmitting(false);
        if (!appointment) return;

        if (props.isPaymentInfoSetup) {
          props.addAppointment(appointment.barberId, appointment);
          if (tabToOpen !== SERVICES_TAB) {
            props.closeChargeModal();
          }
          props.selectRegisterTab(tabToOpen);
        } else {
          props.closeChargeModal();
        }

        props.router.push(props.isBarberUser ? '/barber/register' : '/register');
      });
    },
  }),
  withCheckBarberIsClockedIn(
    'goToRegister',
    props => [props.appointment.barberId],
    props => new Date(props.appointment.end) < new Date(), // allow charging past appointments without clocking in
  ),
  withHandlers({
    onGoToProducts: props => () => {
      props.goToRegister(PRODUCTS_TAB);
    },
    onCharge: props => () => {
      props.goToRegister(SERVICES_TAB);
      CustomerIoTracker.getInstance().track(APPOINTMENT_CHARGE_STARTED);
    },
  }),
  branch(
    props => !canUserViewRegister(props.permissions),
    renderNothing,
  )
);


export default enhance(GoToRegisterButtons);
